// NOTE all the paths MUST be relative. DO NOT START THEM WITH '/'

export const ROUTE_NAMES = {
  INVESTORS_PRICING: 'investors-pricing'
}

const ROUTES = {
  [ROUTE_NAMES.INVESTORS_PRICING]: {
    name: ROUTE_NAMES.INVESTORS_PRICING,
    path: 'investors/pricing'
  }
}

export default [
  {
    name: ROUTES[ROUTE_NAMES.INVESTORS_PRICING].name,
    path: ROUTES[ROUTE_NAMES.INVESTORS_PRICING].path,
    component: (resolve) => require(['./views/pricing.vue'], resolve)
  }
]
